var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"te-tabbar"},[_c('div',{staticClass:"te-tabbar-items"},[_vm._l((_vm.localItems),function(item){return _c('button',{key:item.id,class:[
        'te-tabbar-item',
        _vm.localCurrentItem && item.id === _vm.localCurrentItem.id
          ? 'te-tabbar-item-selected'
          : '',
      ],attrs:{"disabled":item.disabled},on:{"click":function($event){return _vm.select(item)}}},[_c('div',{staticClass:"te-tabbar-item-title"},[_vm._v(_vm._s(item.title))])])}),_c('div',{staticClass:"te-tabbar-buttons"},[_vm._t("buttons")],2)],2),_c('div',{staticClass:"te-tabbar-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }